const IntCashStock = [
    {id: "0", value: "現金股利"},    
    {id: "1", value: "股票股利"},
    {id: "2", value: "現金跟股票股利"}
  ];  
  
export default IntCashStock  